import React, {useEffect} from 'react';
import { useDispatch, useSelector } from "react-redux";
import { NavLink }        from 'react-router-dom';

import {getMediaPath, urlEncodeString} from 'app/functions';
import { getUserOrder, setUserOrder } from 'redux/actions';
import * as routes from 'constants/routes';
import './index.scss';

//assets
import shoppingBag from 'assets/icons/shopping-bag-bold.svg';
import arrow from 'assets/icons/arrow-black.svg';
import accepted_current from 'assets/icons/tracker/tracker-accepted-current.svg';
import delivered_off from 'assets/icons/tracker/tracker-delivered-off.svg';
import delivered_current from 'assets/icons/tracker/tracker-delivered-current.svg';
import packed_off from 'assets/icons/tracker/tracker-packed-off.svg';
import packed_current from 'assets/icons/tracker/tracker-packed-current.svg';
import packed_on from 'assets/icons/tracker/tracker-packed-on.svg';
import delivered_on from 'assets/icons/tracker/tracker-delivered-on.svg';
import accepted_on from 'assets/icons/tracker/tracker-accepted-on.svg';

const Order = (props) =>{

    //import redux state
    const text = useSelector(state => state.config.Translations);
    const deviceState = useSelector(state => state.state.deviceState);
    // const orderStatusArr = useSelector(state => state.config.OrderStatusArr);
    const isDesktop = deviceState === 'desktop' || deviceState === 'desktop-large';
    const UserData = useSelector(state => state.config.UserData);
    const order_id = props.match.params.id;
    const detailedOrder = useSelector(state => state.data.UserDetailedOrders);
    const data = order_id in detailedOrder ? detailedOrder[order_id] : false;
    const dispatch = useDispatch();
    let last_digits = '';
    let orderAdress = {};

    const tracker_status = {2:[{icon:getMediaPath(accepted_current), text:text['tracker_status_accepted']},{icon:getMediaPath(packed_off), text:text['tracker_status_packed']},{icon:getMediaPath(delivered_off), text:text['tracker_status_delivered']}],
        6:[{icon:getMediaPath(accepted_on), text:text['tracker_status_accepted']},{icon:getMediaPath(packed_current), text:text['tracker_status_packed']},{icon:getMediaPath(delivered_off), text:text['tracker_status_delivered']}],
        5:[{icon:getMediaPath(accepted_on), text:text['tracker_status_accepted']},{icon:getMediaPath(packed_on), text:text['tracker_status_packed'] },{icon:getMediaPath(delivered_current),text:text['tracker_status_delivered']}]};


    useEffect(()=>{
        if(!data) {
            dispatch(getUserOrder({order_id:order_id}));
        }
        return () => {
            dispatch(setUserOrder({}));
        }
    },[]);


    if(data) {
        last_digits = UserData.cardsArr.filter(card =>{
            return card.id === data.token_id;
        })[0]?.last_digits;
        for(let key in UserData.addressArr) {
            if(UserData.addressArr[key].id === data.address_id) {
                orderAdress = UserData.addressArr[key];
            }
        }
    }

    const handleBackClick = () => {
        props.history.push(routes.personal_zone + routes.personal_zone_routes.my_orders);
    };


    const getProductsList = () => {
        let list = [];
        data.items.forEach((item, index) => {
            const isCanceled = parseInt(item.status) === 3;
            list.push(
                <div className="product" key={index}>
                    <div className="product-details">
                        <div className="img">
                            <img src={getMediaPath(item.image)} alt="product title"/>
                        </div>
                        <div className="wrapper">
                            <NavLink to={routes.commerce + '/' + item.benefit_id + "/" +item.cda + '/' + urlEncodeString(item.title)} className="title">{item.title}</NavLink>
                            <div className="subtitle">{item.sub_title}</div>
                            <div className="price shekel">{item.price}</div>
                        </div>
                    </div>
                    <div className='left-side'>
                        <div className="supplier-details">
                            <div className="item">
                                <div className="label">{text['order_supplayer']}</div>
                                <div className="value">{item.supplier_title}</div>
                            </div>
                            <div className="item">
                                <div className="label">{text['order_supply_method']}</div>
                                <div className="value">{item.delivery_method_title}</div>
                            </div>
                            <div className="item">
                                <div className="label">{text['order_address']}</div>
                                <div className="value">{data.address_string}</div>
                            </div>
                            <div className="item">
                                <div className="label">{text['order_quantity']}</div>
                                <div className="value">{item.quantity}</div>
                            </div>
                            <div className="item">
                                <div className="label">{text['order_total_price']}</div>
                                <div className="value shekel">{item.total_sum}</div>
                            </div>

                            {item.time_to_supply !== null &&
                            <div className="item">
                                <div className="label">{text['order_astimated_date']}</div>
                                <div className="value">{item.time_to_supply}</div>
                            </div>
                            }
                        </div>
                        <div className="tracker">
                            {!isCanceled && tracker_status[item.status].map((curr, key_index) => {
                                const className = curr.icon.includes('current') ? 'current' : curr.icon.includes('off') ? '' : 'on';
                                return (
                                    <div key={key_index} className={"stage " + className}>
                                        <img src={curr.icon} alt=""/>
                                        <span className='text'>{curr.text}</span>
                                    </div>)
                            })}
                            {isCanceled && <span className='canceled-span'>העסקה בוטלה</span>}
                        </div>
                    </div>
                </div>)
        });
        return list;
    };

    // const handleReceiptLinkClick = () =>{
    //     window.open(data.invoice_link, 'blank');
    // };

    return(
        <div className="mobile-layout open">
            <div className='top'>
                <div className="wrapper">
                    <img src={isDesktop ? getMediaPath(shoppingBag) : getMediaPath(arrow)} alt='' className="icon" onClick={ handleBackClick } />
                    <span className="title">{ text['personal_zone_order_details'] }</span>
                    {isDesktop && <span className='thanks-note'>{text['order_thanks_note']}</span>}
                </div>
            </div>
            { data &&
                <section className="order-page-wrapper">
                    <div className="top-details">
                        <div className='item'>
                            <span className='label'>{ text.last_orders_order_num_label }</span>
                            <span className='value'>{ data.order_id }</span>
                        </div>
                        <div className='item'>
                            <span className='label'>{text['order_order_items']}</span>
                            <span className='value'>{ data.items.length }</span>
                        </div>
                        <div className='item'>
                            <span className='label'>{text['order_date']}</span>
                            <span className='value'>{ data.order_date }</span>
                        </div>
                        <div className='item'>
                            <span className='label'>{text['payment_method']}</span>
                            <span className='value'>כרטיס אשראי ({ last_digits })</span>
                        </div>
                        {/*<button className='receipt-link' onClick={handleReceiptLinkClick}>{text['order_receipt_btn']}</button>*/}
                    </div>
                    <div className="products">
                        { getProductsList() }
                    </div>

                    <div className="order-page-wrapper-links">
                        <div>משהו השתבש או לא לטעמך? אנחנו כאן!</div>
                        <div className="links">
                            <NavLink className="link" to="/">שירות לקוחות</NavLink>
                            <NavLink className="link" to="/">מדיניות החזרות וביטולים</NavLink>
                        </div>
                    </div>
                </section>
            }
        </div>
    )
};

export default Order;
